import { NgModule } from '@angular/core';
import { AvatarModule } from './avatar/avatar.module';
import { DragDropDirective } from './dropzone/dragdrop.directive';
import { DropzoneModule } from './dropzone/dropzone.module';


@NgModule({
  imports: [
    AvatarModule,
    DropzoneModule,
  ],
  exports: [
    AvatarModule,
    DropzoneModule
  ]
})
export class IrisModule { }
